
  var _styles = {
  "reward-coupon-container": {
    "display": "flex",
    "width": "100%",
    "alignItems": "center",
    "justifyContent": "center"
  },
  "reward-coupon-bg": {
    "display": "flex",
    "flexDirection": "row",
    "width": "9.09333rem",
    "height": "2.08rem",
    "paddingTop": 0,
    "paddingRight": "0.32rem",
    "paddingBottom": 0,
    "paddingLeft": "0.32rem",
    "borderRadius": "0.32rem",
    "backgroundColor": "rgba(255,255,255,0.6)"
  },
  "reward-coupon-price-section": {
    "display": "flex",
    "flexDirection": "column",
    "position": "relative",
    "minWidth": "1.6rem"
  },
  "reward-coupon-price-box": {
    "display": "flex",
    "flexDirection": "row",
    "alignItems": "flex-end",
    "justifyContent": "center",
    "height": "1.12rem",
    "marginTop": "0.21333rem",
    "position": "relative"
  },
  "reward-coupon-currency": {
    "color": "rgb(255,45,25)",
    "fontWeight": "700",
    "fontSize": "0.42667rem",
    "lineHeight": "1.12rem",
    "position": "relative",
    "top": "0.13333rem"
  },
  "reward-coupon-amount": {
    "color": "rgb(255,45,25)",
    "fontWeight": "700",
    "fontSize": "0.8rem",
    "lineHeight": "1.12rem"
  },
  "reward-coupon-threshold": {
    "color": "rgb(255,45,25)",
    "fontFamily": "PingFang SC",
    "fontSize": "0.29333rem",
    "lineHeight": "0.42667rem",
    "textAlign": "center",
    "position": "relative",
    "top": "-0.09333rem",
    "alignItems": "center",
    "justifyContent": "center"
  },
  "reward-coupon-info-section": {
    "display": "flex",
    "flexDirection": "column",
    "flex": 1,
    "marginLeft": "0.2rem",
    "marginTop": "0.56rem"
  },
  "reward-coupon-title": {
    "color": "rgb(17,17,17)",
    "fontFamily": "PingFang SC",
    "fontWeight": "500",
    "fontSize": "0.37333rem",
    "lineHeight": "0.53333rem",
    "overflow": "hidden",
    "width": "100%"
  },
  "reward-coupon-subtitle": {
    "color": "rgb(136,136,136)",
    "fontFamily": "PingFang SC",
    "fontSize": "0.29333rem",
    "lineHeight": "0.42667rem",
    "overflow": "hidden",
    "width": "100%",
    "marginTop": "0.13333rem"
  },
  "reward-coupon-button-section": {
    "display": "flex",
    "flexDirection": "column",
    "justifyContent": "center",
    "alignItems": "center",
    "marginRight": "0.16rem",
    "width": "1.49333rem"
  },
  "reward-coupon-button": {
    "display": "flex",
    "flexDirection": "row",
    "alignItems": "center",
    "justifyContent": "center",
    "flexShrink": 0,
    "width": "1.49333rem",
    "height": "0.64rem",
    "borderWidth": "0.01333rem",
    "borderStyle": "solid",
    "borderColor": "rgb(255,45,25)",
    "borderRadius": "0.32rem"
  },
  "reward-coupon-button-text": {
    "color": "rgb(255,45,25)",
    "fontFamily": "PingFang SC",
    "fontWeight": "500",
    "fontSize": "0.32rem",
    "lineHeight": "0.42667rem",
    "textAlign": "center"
  }
};



  module.exports = _styles;
  